import { Form } from 'antd';

const HmsFormItem = ({ name, label, validationLabel, required, validators = [], children, suffix, ...props }) => {
    // Helper function to get a string message from label
    const getLabelMessage = (label, validationLabel, fieldName) => {
        // Priority 1: Use validationLabel if provided
        if (validationLabel) {
            return validationLabel + ' is required!';
        }
        
        // Priority 2: Use label if it's a string
        if (label && typeof label === 'string') {
            return label + ' is required!';
        }
        
        // Priority 3: Use field name as fallback
        if (fieldName) {
            const capitalizedName = fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
            return capitalizedName + ' is required!';
        }
        
        return 'Required!';
    };

    return (
        suffix ?
            <Form.Item
                className="mb-2"
                labelCol={ {className: '!p-0 !pb-1'} }
                required={required}
                label={label &&
                    <span className=" text-gray-500 custom-form-label-text-size">
                        {label}{typeof label == 'string' ? ':' : ''}
                    </span>}
                colon={false}
            >
                <div className="flex gap-3 items-center">
                    <Form.Item
                        className="flex-1 mb-0"
                        name={name}
                        rules={required ? [{ required: true, message: getLabelMessage(label, validationLabel, name) }, ...validators] : [...validators]}
                        {...props}
                    >
                        {children}
                    </Form.Item>
                    {suffix &&
                        <div className="flex-shrink-0">{suffix}</div>
                    }
                </div>
            </Form.Item>
        :
            <Form.Item
                className="mb-2"
                labelCol={ {className: '!p-0 !pb-1'} }
                label={label &&
                    <span className=" text-gray-500 custom-form-label-text-size">
                        {label}{typeof label == 'string' ? ':' : ''}
                    </span>}
                colon={false}
                name={name}
                rules={required ? [{ required: true, message: getLabelMessage(label, validationLabel, name) }, ...validators] : [...validators]}
                {...props}
            >
                {children}
            </Form.Item>
    )
}

export default HmsFormItem